import { render, staticRenderFns } from "./ClothPrint.vue?vue&type=template&id=9396d5ea&scoped=true&lang=html&"
import script from "./ClothPrint.vue?vue&type=script&lang=js&"
export * from "./ClothPrint.vue?vue&type=script&lang=js&"
import style0 from "./ClothPrint.vue?vue&type=style&index=0&id=9396d5ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9396d5ea",
  null
  
)

export default component.exports